import { $axios } from "../../config/axios";
import ResourceManagmentService from "@/services/ResourceManagementService"; // Include the labtest, resources operation

const labTestStore = {
  namespaced: true,
  state: {
    date: "",
    labTests: [],
    locationLabTests: [],
  },
  getters: {
    getDate: function(state) {
      return state.date;
    },
    getLabTests: function(state) {
      return state.labTests;
    },
    getLocationLabTests: function(state) {
      return state.locationLabTests;
    },
  },
  mutations: {
    SET_DATE(state, date) {
      state.date = date;
    },
    SET_LAB_TESTS: function(state, tests) {
      state.labTests = tests;
    },
    SET_LOCATION_LAB_TESTS: function(state, tests) {
      state.locationLabTests = tests;
    },
  },
  actions: {
    changeDate({ commit }, date) {
      commit("SET_DATE", date);
    },
    fetchAllLabTests: async (context, params = {}) => {
      console.log("hit");
      try {
        console.log(params);
        const response = await ResourceManagmentService.fetchLabTests(params);
        context.commit("SET_LAB_TESTS", response.data);
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    fetchLabTestsByLocation: async (context, params = {}) => {
      try {
        const response = await ResourceManagmentService.fetchLabTestsByLocation(
          params
        );
        context.commit("SET_LOCATION_LAB_TESTS", response.data.lab_tests);
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    addLabTests: async (context, labTests) => {
      console.log(labTests);
      try {
        const response = await ResourceManagmentService.addLabTestsToPond(
          labTests
        );
        console.log(response);
        return response.data;
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    deleteLabTest: async (context, record_id) => {
      console.log(record_id);
      try {
        const response = await ResourceManagmentService.deleteLabTestFromPond(
          record_id
        );
        return response.data;
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
  },
};

export default labTestStore;
